import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tn_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("tn_cart", JSON.stringify(items));
  }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const found = prev.find((i) => i.lookup_key === product.lookup_key);
      if (found)
        return prev.map((i) =>
          i.lookup_key === product.lookup_key ? { ...i, quantity: i.quantity + 1 } : i
        );
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const setQty = (lookup_key, quantity) => {
    if (quantity <= 0) return remove(lookup_key);
    setItems((prev) => prev.map((i) => (i.lookup_key === lookup_key ? { ...i, quantity } : i)));
  };

  const remove = (lookup_key) =>
    setItems((prev) => prev.filter((i) => i.lookup_key !== lookup_key));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(
    () => ({ items, add, setQty, remove, clear, count, total }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items, count, total]
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
